export default __webpack_public_path__ + "static/media/mapLegend2.936de28c.png";